/** The references object of all modules needed for components initialization */
var references = {
	'header.custom': require('./header.custom'),
	'search.custom': require('./search.custom'),
	/** Components from extension cartridge */
	'global.custom': require('./global.custom'),
	'searchsuggest.custom': require('./searchsuggest.custom')
};

/** The components initialization configuration object */
var configuration = {
	'global' : {
		'components': {
			'header.custom': {},
			'global.custom': {},
			'searchsuggest.custom': {
				'enabled' : true
			},
		}
	},
	'product': {
		'options': {
			'showNavigation': true,
		},
		'components': {
			'carousel': {},
			'image': {
				'options': {
					'enableImgDots': true,
					'minimizedHeaderHeight': 91,
					'stickykit' : {
						'options' : {
							'inner_scrolling': true,
							'bottoming': true,
							'spacer': false,
							'parent': '.js-pdp-product_images',
						}
					}
				}
			}
		}
	},
	'search': {
		'components': {
			'search.custom' : {},
		}
	}
};

module.exports = {
	'configuration': configuration,
	'references': references
};
